import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../blogs/utils/NotFound";

export const slugToFileName = (slug) => {
    return slug
        .split("-")
        .map((word) => {
            if (/^[0-9]+$/.test(word)) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join("") + ".js";
};

const FeatureWrapper = () => {
    const { featureId } = useParams();

    const FeatureComponent = useMemo(() => {
        const context = require.context("../../features/", false, /\.js$/);
        const fileName = slugToFileName(featureId);

        try {
            const path = context.keys().find((p) =>
                p === `./${fileName}` ||
                p.toLowerCase() === `./${fileName.toLowerCase()}`
            );
            if (!path) return null;
            return context(path).default;
        } catch (err) {
            console.error("Feature loading error:", err);
            return null;
        }
    }, [featureId]);

    if (!FeatureComponent) return <NotFound />;
    return <FeatureComponent />;
};

export default FeatureWrapper;
